// Brand test: saves the visitor's Kameleoon arm on the cart as the hidden attribute _store_brand, so orders can be split
// by arm in the Shopify admin. The arm is only known on pages where Kameleoon calls StoreBrand.set() (see
// snippets/brand-test.liquid); the attribute stays on the cart for the rest of the visit.
(function () {
	const ATTRIBUTE = '_store_brand';
	const TAGGED_KEY = 'store_brand_cart_tagged';

	// Also tags an empty cart: attributes are kept when products are added, so the tag is in place before the visitor
	// can reach checkout (the theme dispatches cart:change only seconds after adding to cart)
	function tagCart(brand) {
		try {
			sessionStorage.setItem(TAGGED_KEY, brand);
		} catch (error) {
			// Storage unavailable: the cart is tagged again on every page Kameleoon runs on instead
		}

		fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ attributes: { [ATTRIBUTE]: brand } }),
		}).catch(() => {});
	}

	function onArm(brand) {
		let alreadyTagged = false;
		try {
			alreadyTagged = sessionStorage.getItem(TAGGED_KEY) === brand;
		} catch (error) {
			// Storage unavailable: tag every time
		}

		if (!alreadyTagged) tagCart(brand);
	}

	document.addEventListener('store-brand:change', (event) => onArm(event.detail.brand));

	// Kameleoon may run before this deferred script, so the arm can already be set
	if (window.StoreBrand && window.StoreBrand.get()) onArm(window.StoreBrand.get());

	// Backup for a new cart later in the session, e.g. after an order
	document.documentElement.addEventListener('cart:change', (event) => {
		const brand = window.StoreBrand && window.StoreBrand.get();
		const cart = event.detail && event.detail.cart;
		if (brand && cart && cart.attributes && cart.attributes[ATTRIBUTE] !== brand) tagCart(brand);
	});
})();
